import { Dispatch } from 'redux';
import { History } from 'history';
import { State } from '../state';
import { ExtraArguments } from '../extraArguments';
import { CompetitionUserPoint } from '../../userApi';
import { toast } from './toast';
import { StyleState } from '../../utils/styles';

export const ACTION_COMPLETE_TOAST_DURATION_MS = 5000;

export const navigateToCompetitionHome = (history: History, competitionName: string) => {
  history.push(`/${competitionName}`);
};

export const showActionCompletedToast = (
  dispatch: Dispatch,
  getState: () => State,
  i18n: ExtraArguments['i18n'],
  points?: CompetitionUserPoint
) => {
  const t = i18n.getFixedT(i18n.language, 'story');
  const message = points && points.points > 0
    ? t('Action completed! You\'ve earned {{points}} points.', { points: points.points })
    : t('Action completed!');
  toast({
    message,
    style: StyleState.Success
  }, ACTION_COMPLETE_TOAST_DURATION_MS)(dispatch, getState);
};

export const finishActionAndGoHome = (
  dispatch: Dispatch,
  getState: () => State,
  extra: ExtraArguments,
  points?: CompetitionUserPoint
) => {
  const { competition } = getState();
  navigateToCompetitionHome(extra.history, competition.name);
  showActionCompletedToast(dispatch, getState, extra.i18n, points);
};
